import React from 'react';
import { MdAdd } from 'react-icons/md';

interface IProps {
    onClick: () => void;
    disabled?: boolean;
}

export const NewChatButton: React.FC<IProps> = ({ onClick, disabled }) => (
    <button
        type="button"
        className="chat-ai-sidebar__new-chat"
        onClick={onClick}
        disabled={disabled}
        aria-label="Новый чат"
    >
        <span className="chat-ai-sidebar__new-chat-icon" aria-hidden>
            <MdAdd size={17} />
        </span>
        <span className="chat-ai-sidebar__new-chat-label">Новый чат</span>
        <span className="chat-ai-sidebar__new-chat-aurora" aria-hidden />
    </button>
);
